import {
  IApiResponse,
  IDRHortonIntegrationConfigRequest,
  IDRHortonIntegrationConfigResponse,
  IFeatureFlagsResponse,
  PlatformModules,
} from "@miplatform/types";
import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_TENANT_CONFIG = `${SUBSCRIPTION_SERVICE}/tenant-config`;

export const tenantConfig = {
  getFeatureFlags: async ({
    tenantId,
  }: {
    tenantId?: string;
  } = {}): IApiResponse<IFeatureFlagsResponse> => {
    // Tenant ID is optional because we want to get the feature flags for the current tenant if no tenant ID is provided.
    // This is useful for the feature flag provider, which needs to get the feature flags for the current tenant.
    const options = await apiOptions({
      url: tenantId
        ? `${API_TENANT_CONFIG}/feature-flags/${tenantId}`
        : `${API_TENANT_CONFIG}/feature-flags`,
      method: "get",
    });
    return apiRequest(options);
  },
  getDRHortonIntegrationConfig:
    async (): IApiResponse<IDRHortonIntegrationConfigResponse> => {
      const options = await apiOptions({
        url: `${API_TENANT_CONFIG}/dr-horton`,
        method: "get",
      });
      return apiRequest(options);
    },
  updateDRHortonIntegrationConfig: async ({
    data,
  }: {
    data: IDRHortonIntegrationConfigRequest;
  }): IApiResponse<IDRHortonIntegrationConfigResponse> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/dr-horton`,
      method: "put",
      data,
    });
    return apiRequest(options);
  },
  enableModuleAccess: async ({
    tenantId,
    module,
  }: {
    tenantId: string;
    module: PlatformModules;
  }): IApiResponse<unknown> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/${tenantId}/module-access/${module}`,
      method: "put",
    });
    return apiRequest(options);
  },
  disableModuleAccess: async ({
    tenantId,
    module,
  }: {
    tenantId: string;
    module: PlatformModules;
  }): IApiResponse<unknown> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/${tenantId}/module-access/${module}`,
      method: "delete",
    });
    return apiRequest(options);
  },
  enableNonModuleFeatureFlagAccess: async ({
    tenantId,
    featureFlag,
  }: {
    tenantId: string;
    featureFlag: keyof IFeatureFlagsResponse;
  }): IApiResponse<unknown> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/${tenantId}/feature-flag-access/${featureFlag}`,
      method: "put",
    });
    return apiRequest(options);
  },
  disableNonModuleFeatureFlagAccess: async ({
    tenantId,
    featureFlag,
  }: {
    tenantId: string;
    featureFlag: keyof IFeatureFlagsResponse;
  }): IApiResponse<unknown> => {
    const options = await apiOptions({
      url: `${API_TENANT_CONFIG}/${tenantId}/feature-flag-access/${featureFlag}`,
      method: "delete",
    });
    return apiRequest(options);
  },
};
